module.exports = __webpack_public_path__ + "lechery.d3c0db67.png";